import * as React from "react";
import { createRoot } from "react-dom/client";
import {SearchBox} from "./Components/SearchBox";
import {SearchResultsPage} from "./Components/SearchResultsPage";


// TODO move to project level
// as defined in Header feature
const headerSearchContainers = document.querySelectorAll(".feature-header .search-container");

const language = document.getElementById("current-sitecore-context").getAttribute("data-language");

if (headerSearchContainers.length > 0) {
    const container = headerSearchContainers[0];
    createRoot(container).render(
        <SearchBox
            placeholderText={container.getAttribute("data-placeholder")}
            searchPageUrl={container.getAttribute("data-searchpage")}
            language={language}
        />
    );
}

const searchPageContainers = document.querySelectorAll(".search-page-container");

const getUrlParam = (paramName: string) => {
    // Non IE browsers
    if (typeof URL === "function") {
        const urlObj = new URL(window.location.href);
        return urlObj.searchParams.get(paramName);
    }
    // IE Hack from StackOverflow
    const url = window.location.href;
    paramName = paramName.replace(/[\[\]]/g, "\\$&");
    // tslint:disable-next-line:one-variable-per-declaration
    const regex = new RegExp("[?&]" + paramName + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ""; }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

if (searchPageContainers.length > 0) {
    const searchPageContainer = searchPageContainers[0];
    const query = getUrlParam("q");

    const nextPage = searchPageContainer.getAttribute("data-next-text");
    const previousPage = searchPageContainer.getAttribute("data-previous-text");

    const resultAmount = searchPageContainer.getAttribute("data-result-amount-text");
    const resultAmountLoadingText = searchPageContainer.getAttribute("data-reuslt-amount-loading-text");
    const resultDataText = searchPageContainer.getAttribute("data-result-stats-text");
    const pageSize = searchPageContainer.getAttribute("data-page-size");
    const visiblePages = searchPageContainer.getAttribute("data-visible-pages");
    const pageTitle = searchPageContainer.getAttribute("data-page-title");
    createRoot(searchPageContainer).render(
        <div><React.Suspense fallback={<></>}>
        <SearchResultsPage
            mainTitle={pageTitle}
            searchQuery={query}
            resultAmountText={resultAmount}
            resultAmountLoadingText={resultAmountLoadingText}
            previousPageText={previousPage}
            nextPageText={nextPage}
            pageSize={parseInt(pageSize, 10)}
            visiblePages={parseInt(visiblePages, 10)}
            resultStatsText={resultDataText}
            language={language}
        /></React.Suspense></div>
    );
}
